import React from 'react';
// @ts-ignore
import { Button, CentredModal } from 'components/UI';
import styles from './styles.scss';

interface ModalProps {
  modalOpen: boolean;
  toggleModal: () => void;
  deleteDocument: (id: number) => void;
  name: string;
  extension: string;
  documentId: number;
}

const Modal = ({ modalOpen, toggleModal, deleteDocument, name, extension, documentId }: ModalProps) => (
  <CentredModal isOpen={modalOpen} onAfterOpen={() => {}} onRequestClose={toggleModal} width={370} height={265}>
    <div className={styles.modalBody}>
      <div className={styles.name}>Подтверждение удаления</div>
      <span className={styles.text}>Подтвердите удаление документа:</span>
      <span className={styles.textBold}>
        {name}
        {extension}
      </span>
      <div className={styles.buttons}>
        <Button
          color="blue"
          onClick={(event: React.MouseEvent) => {
            deleteDocument(documentId);
            event.stopPropagation();
            toggleModal();
          }}
        >
          Удалить
        </Button>
        <Button onClick={toggleModal}>Отменить</Button>
      </div>
    </div>
  </CentredModal>
);

export default Modal;
